import { Flex, Grid, Label, Text } from '@approvalmax/ui/src/components';
import get from 'lodash/get';
import { FC } from 'react';
import { t } from 'services/localization';
import { noValue } from 'shared/constants';
import { paymentDetailsFields } from 'shared/constants/(payments)';

import { LineItemPaymentSummaryProps } from './LineItemPaymentSummary.types';

export const LineItemPaymentSummary: FC<LineItemPaymentSummaryProps> = (props) => {
    const { billCurrency, quote, paymentDetails } = props;

    return (
        <Grid gap={16} gridTemplateColumns='auto 280px'>
            <Grid padding='16 0' gap={8} alignContent='start'>
                <Flex spacing='8'>
                    <Label spacing='0' size='small'>
                        {t('wallet')}
                    </Label>

                    <Text font='label' fontSize='small'>
                        {paymentDetails?.bankAccountDetails.bankAccount.currencyIsoCode ?? noValue}
                    </Text>
                </Flex>

                <Flex spacing='8'>
                    <Label spacing='0' size='small'>
                        {t('bill_currency_1')}
                    </Label>

                    <Text font='label' fontSize='small'>
                        {billCurrency}
                    </Text>
                </Flex>

                {paymentDetailsFields.map((field) => {
                    const value = get(paymentDetails, field.path);

                    if (!value) {
                        return null;
                    }

                    return (
                        <Flex spacing='8' key={field.path}>
                            <Label spacing='0' size='small'>
                                {field.title}:
                            </Label>

                            <Text font='label' fontSize='small'>
                                {field.getDisplayValue ? field.getDisplayValue(value) : value}
                            </Text>
                        </Flex>
                    );
                })}
            </Grid>

            {quote}
        </Grid>
    );
};
